import React, { useEffect, useRef, useState } from 'react';
import { Protected } from '@components/layout/Protected';
import { Alert, Container, Snackbar } from "@mui/material";
import { TableDataV2 } from '@/components/common/Tablev2';
import { Loading } from '@/components/common/Loading';
import { Props } from './TimeZone.type';
import { TimeZoneService } from '@/service/services/TimeZone.service';
import { ModalTimeZone } from '@/components/Modal/ModalTimeZone/ModalTimeZone';
import { ModalTimeZoneDelete } from '@/components/Modal/ModalTimeZoneDelete';
import ___PHRASE from '@/service/translate/translateService';

export const TimeZoneView: React.FC<Props> = (props:any): JSX.Element => {

   const [loading, setLoading] = useState<boolean>(false);
   const [timeZones, setTimeZones] = useState([]);
   const [comboTimeZones, setComboTimeZones] = useState([]);
   const [showTimeZoneModal, setShowTimeZoneModal] = useState<boolean>(false);
   const [showTimeZoneDeleteModal, setShowTimeZoneDeleteModal] = useState<boolean>(false);
   const [actionSelected, setActionSelected] = useState<String>('');
   const [timeZoneSelected, setTimeZoneSelected] = useState<String>('');
   const [snackBarConfig, setSnackBarConfig] = useState<any>({
       open: false,
       severity: 'error',
       message: 'Error',
       autoHideDuration: 3000,
   });

   useEffect(() => {
    getTimeZone()
   },[]);

   const getTimeZone = async () => {
      setLoading(true);
      const response = await TimeZoneService.getTimeZone();
      if (response.data) {
        setTimeZones(response.data || [])
      }
      await TimeZoneService.getDataTimeZone().then((data) => {
         setComboTimeZones(data.data)
      })

      setLoading(false);
   }

   function RecuperarData(value){
      console.log(value);
      setTimeZoneSelected(value);
   }

  return (
      <Protected>
         {loading && <Loading/>}
         <Snackbar
            open={snackBarConfig.open}
            autoHideDuration={snackBarConfig.autoHideDuration}
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                  {snackBarConfig.message || ""}
            </Alert>
         </Snackbar>
         <Container>
            <TableDataV2
               title={___PHRASE("zonashorarias")}
               data={timeZones}
               header={[
                  { name: 'description', label: ___PHRASE("descripcion"), filter: false, Chip: true },
                  // { name: 'operation', label: 'Operación', filter: false, Chip: true },
                  { name: 'time_zone', label: ___PHRASE("zonaHoraria"), filter: false, Chip: true }
               ]}
               actionSelect={setActionSelected}
               setModalSave={setShowTimeZoneModal}
               setModalDelete={setShowTimeZoneDeleteModal}
               status_action
               // checkbox
               RecuperarData={RecuperarData}
            />
         </Container>

         { 
            showTimeZoneModal && (
               <ModalTimeZone
                  open={showTimeZoneModal}
                  closeModal={()=>{setShowTimeZoneModal(false)}}
                  actionSelected={actionSelected}
                  onListZoneTime={getTimeZone}
                  timeZone={timeZoneSelected}
                  comboTimeZones={comboTimeZones}
                  getSnackBar={setSnackBarConfig}
                  clearState={()=>{setTimeZoneSelected('')}}
               />
            )
         }
         {
            actionSelected === 'delete' && (
               <ModalTimeZoneDelete
                  open={showTimeZoneDeleteModal}
                  closeModal={()=>{setShowTimeZoneDeleteModal(false)}}
                  actionSelected={actionSelected}
                  onListZoneTime={getTimeZone}
                  timeZone={timeZoneSelected}
                  getSnackBar={setSnackBarConfig}
                  clearState={()=>{setTimeZoneSelected('')}}
               />
            )
         }
      
      </Protected>
   )
};
